export default {
//	getData(state) {
//		return state.userInfo.phone
//	}
}


// WEBPACK FOOTER //
// ./src/store/mp/user_center/users/getters.js